<script setup>
import { getRequest, postRequest, putRequest } from "@/utils/request.js";
import { message } from "ant-design-vue";
import { reactive, ref, unref } from "vue";

const emit = defineEmits(["ok"]);
const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);
const imageUrl = ref("");
const formModel = ref({});
const formRef = ref();
const rules = reactive({
  name: [
    {
      required: true,
      message: "请输入分类名称",
      trigger: "blur",
    },
  ],
});

const handleAdd = (record) => {
  handleEdit({ ...record });
};

const handleEdit = (record) => {
  formModel.value = Object.assign({}, { ...record });
  if (formModel.value.parentId === "0") {
    formModel.value.parentId = null;
  }
  loadCategory();
  open.value = true;
};

const handleClose = () => {
  open.value = false;
  formRef.value.resetFields();
  imageUrl.value = "";
};

const handleConfirm = () => {
  formRef.value.validate().then(async () => {
    const unrefFormModel = unref(formModel);
    let request;
    if (unrefFormModel.id) {
      request = putRequest;
    } else {
      request = postRequest;
    }
    request("/jobTypePreferenceCategory", unrefFormModel).then((response) => {
      if (response.success) {
        message.success("保存成功");
        emit("ok");
        handleClose();
      } else {
        message.error("保存失败。" + response.message);
      }
    });
  });
};

const category = ref([]);
const loadCategory = () => {
  getRequest("/jobTypePreferenceCategory/tree").then((response) => {
    if (response.success) {
      category.value = response.data;
    }
  });
};

defineExpose({
  handleAdd,
  handleEdit,
  handleClose,
  title,
});
</script>

<template>
  <a-modal
    width="800px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
    @ok="handleConfirm"
  >
    <a-form
      ref="formRef"
      :labelCol="{ span: 3 }"
      :wrapperCol="{ span: 24 }"
      :model="formModel"
      :rules="rules"
    >
      <a-form-item label="分类名称" name="name">
        <a-input v-model:value="formModel.name" placeholder="请输入分类名称" />
      </a-form-item>
      <a-form-item v-if="category.length" label="所属分类" name="parentId">
        <a-tree-select
          v-if="category.length"
          v-model:value="formModel.parentId"
          defaultExpandAll
          :show-line="true"
          :show-icon="false"
          blockNode
          :tree-data="category"
          :field-names="{
            children: 'children',
            label: 'name',
            value: 'id',
          }"
          placeholder="请选择所属分类"
        >
        </a-tree-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style scoped lang="scss"></style>
